
import { namespace } from 'vuex-class';
import { Vue, Prop, Component } from 'vue-property-decorator';

const Language = namespace('language');

@Component({ name: 'ProductionNewsBlock' })
export default class ProductionNewsBlock extends Vue {
	@Prop({ required: true }) content: string | null;

	@Language.Getter locale: string;
}
